import React from 'react'
import SimplePage from '../../../../../component/common/landing-page/WidgetFormLandingPage'

export default function WidgetFormLandingPage() {
    return (
        <><SimplePage/></>
    )
}
